import { TRANSLATIONS } from '../core/constants';

export default function translate(key, language) {
  return TRANSLATIONS[language] ? TRANSLATIONS[language][key] : TRANSLATIONS['de'][key];
}
